import { Locale } from '../types';

const DOCS_ORIGIN = 'https://docs.2gis.com';

/**
 * Формирует ссылку на документацию docs.2gis.com с учётом локали.
 * - Для en: добавляет префикс /en, иначе документация откроется на русском
 * - Для остальных локалей: без языкового префикса, чтобы не ловить редирект с /ru
 *
 * @example
 * getDocsUrl('/api/navigation/radar/overview', 'ru')
 * // => 'https://docs.2gis.com/api/navigation/radar/overview'
 *
 * @example
 * getDocsUrl('/api/navigation/radar/overview', 'en')
 * // => 'https://docs.2gis.com/en/api/navigation/radar/overview'
 */
export const getDocsUrl = (path: string, locale: Locale): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const localePrefix = locale === 'en' ? '/en' : '';

  return `${DOCS_ORIGIN}${localePrefix}${normalizedPath}`;
};
